import React from 'react';

const PhotoOutlined = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
    >
        <path
            d="m0.541 5.416 6.659 6.659a0.541 0.541 0 0 0 0.766 0l4.492 -4.492m-8.667 0.541 2.325 -2.325a0.541 0.541 0 0 1 0.766 0l3.409 3.409m-0.745 -6.162h0.407m-0.407 0.407h0.407M4.875 12.459h3.25c1.516 0 2.275 0 2.854 -0.295a2.693 2.693 0 0 0 1.184 -1.184c0.295 -0.579 0.295 -1.338 0.295 -2.854v-3.25c0 -1.516 0 -2.275 -0.295 -2.854A2.693 2.693 0 0 0 10.979 0.837C10.4 0.541 9.641 0.541 8.125 0.541h-3.25c-1.516 0 -2.275 0 -2.854 0.295A2.693 2.693 0 0 0 0.837 2.021C0.541 2.6 0.541 3.359 0.541 4.875v3.25c0 1.516 0 2.275 0.295 2.854a2.693 2.693 0 0 0 1.184 1.184c0.579 0.295 1.338 0.295 2.854 0.295ZM10.291 3.25a0.541 0.541 0 1 1 -1.084 0 0.541 0.541 0 0 1 1.084 0Z"
            stroke="white"
            strokeWidth="1.0836428571428571"
            strokeLinecap="round"
        />
    </svg>
);
export default PhotoOutlined;
